<template>
  <v-flex class="logo-container-modal">
    <file-uploader v-if="!newImage" v-model="newImage" filetype="image/x-png, image/gif, image/jpeg, .pdf, .doc, .docx">
      <template v-slot:activator>
        <div class="add-logo-container">
          <v-icon
            :color="colors.hwayzGray"
            size="48"
          >
            fa-cloud-upload-alt
          </v-icon>
          <label>Drag and Drop</label>
          <label>or</label>
          <label>browse</label>
        </div>
      </template>
    </file-uploader>
    <v-flex v-else class="logo-image">
      <img :src="newImage.fileURL">
    </v-flex>
    <v-flex class="logo-button-container">
      <v-btn
        class="submit-logo-button"
        :color="colors.hwayzBrandBlue"
        @click="clearUploader"
      >
        {{ btnText }}
      </v-btn>
    </v-flex>
  </v-flex>
</template>
<script>
import FileUploader from '../../components/uiUtils/FileUploader'
import colors from '../../scss/_colors.scss'
export default {
  components: {
    FileUploader
  },
  props: {
    btnText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      colors,
      newImage: null
    }
  },
  methods: {
    clearUploader() {
      if (this.newImage) {
        this.$emit('upload-new-image', this.newImage)
        this.newImage = null
      }
    }
  }

}
</script>

<style lang="sass">
.upload-logo-container
  background: $color-grey
.upload-logo-container, .logo-container
  width: 95%
  height: 120px
  margin: 1rem auto 1.5rem
  display: flex
  align-content: center
  justify-content: center
.logo-container
  img
    width: 100%
    height: 100%
  div
    margin: 0.2rem
  &-placeholder
    display: flex
    align-items: center
    justify-content: center
    margin: 0 auto
    position: relative
    height: 100% !important
    width: 100% !important
  .logo-hover
    pointer-events: none
    position: absolute
    bottom: 0
    top: 0
    left: 0
    right: 0
    margin: 0 !important
    background-color: $hwayzMediumGray
    opacity: 0.9
    color: $hwayzWhite
    .hover-icon
      pointer-events: all
      font-size: $hwayzFont1rem6
      position: absolute
      top: 0.5rem !important
      right: 0.5rem !important
      cursor: pointer
.logo-container-modal, .logo-image
  margin: 1rem auto 1.5rem
  display: flex
  align-content: center
  justify-content: center
  flex-direction: column
.logo-container-modal
  width: 100%
.logo-container-modal img
  height: 100%
  width: 100%
.logo-image
  height: 160px
  width: 250px
.add-logo-container
  height: 160px
  width: 130px
  border: .1rem solid $hwayzce
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  margin: 2rem auto
  position: relative
.add-logo-container label
  display: block
  color: $color-grey
.submit-logo-button
  width: 100%
  margin: 0 auto !important
  border-radius: 3px
  font-size: 1.2rem !important
  color: $hwayzWhite !important
.submit-logo-button .v-btn__content
  color: white !important
  font-weight: 500 !important
.submit-logo-button:hover
  background-color: $hwayzBrandGold !important
</style>
